import type {ApiRequestOptions} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import getToken from './getAnalyticsToken'

// Получает заголовок для защиты от автоматизации получения телефонных номеров из объявлений.
// Специально анонимная функция.
export default async function (url: string): Promise<ApiRequestOptions> {
    return {
        headers: {
            // Не 'x-csrf-token' т.к. этот токен не является CSRF токеном,
            // а содержит шифрованный ID объявления.
            'csrf-token': await getToken(url),
        },
    }
}
